import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { BeneficiarioCriptomoneda } from '../../interfaces/beneficiario-criptomoneda.interface';
import { RecipientCriptoService } from '../../services/recipient-cripto.service';
import { MediosCriptoService } from '../../services/medios-cripto.service';
import { EstadoRed } from 'src/app/shared/utils/red-cripto';
import { AddBeneficiaryComponent } from '../calculator-cryto/components/add-beneficiary/add-beneficiary.component';

@Component({
  selector: 'app-recipient-cripto',
  templateUrl: './recipient-cripto.component.html',
  styleUrls: ['./recipient-cripto.component.sass']
})
export class RecipientCriptoComponent  implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  usuarioID: number | undefined;
  listaCuentas: BeneficiarioCriptomoneda[] = [];
  @Input() seleccionable = false;
  @Output() seleccion: EventEmitter<BeneficiarioCriptomoneda> = new EventEmitter();

  /**
   * Encendida/pausada de cada red, para marcar "Red pausada" en la lista. En
   * la libreta no se bloquea nada: un beneficiario de una red pausada se
   * puede ver, editar y dar de baja; lo que no se puede es enviarle.
   */
  estadoRedes: EstadoRed[] = [];

  constructor(
    private store: Store<AppState>,
    private accountRecipientService: RecipientCriptoService,
    private dialog: MatDialog,
    private mediosCripto: MediosCriptoService,
  ) {
    this.initFormCuenta();
  }



  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  initFormCuenta() {
    this.subscriptions.add(
      this.store.select('auth').subscribe(async ({ user }) => {
        this.usuarioID = user?.usuarioId;
        if(this.usuarioID){
          this.listaCuentas = await this.accountRecipientService.getByUser(this.usuarioID);
        }
      })
    );

  }
  ngOnInit() {
    void this.cargarRedes();
  }

  /** `listar()` nunca rechaza: si Nest no responde, ninguna red se marca pausada. */
  private async cargarRedes(): Promise<void> {
    this.estadoRedes = await this.mediosCripto.listar();
  }

  async reloadAccount(){
    if(this.usuarioID){
      this.listaCuentas = await this.accountRecipientService.getByUser(this.usuarioID);
    }
  }

  openCreateDialog(cuenta?: BeneficiarioCriptomoneda):void{
    const isMobile = window.innerWidth < 768;
    const dialogData: any = { userID: this.usuarioID };
    if(cuenta){ dialogData.type = 'UPDATE'; dialogData.beneficiario = cuenta; }
    const dialogRef = this.dialog.open(AddBeneficiaryComponent, {
      data: dialogData,
      disableClose: true,
      panelClass: 'aguacate-dialog',
      maxWidth: isMobile ? '95vw' : '560px',
      minWidth: isMobile ? '90vw' : '500px',
      maxHeight: '90vh',
    });
    dialogRef.afterClosed().subscribe(async result => {
      if(result == true && this.usuarioID){
        this.listaCuentas = await this.accountRecipientService.getByUser(this.usuarioID);
      }
      // El diálogo pudo enterarse de una red recién pausada (422).
      void this.cargarRedes();
    })
  }

  onSeleccion(cuenta:BeneficiarioCriptomoneda ){
    this.seleccion.emit(cuenta);
  }

}
